import React from "react";

import ObjetivoV2AccordionCard from "./ObjetivoV2AccordionCard";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";

export default function ObjetivoV2Vendedores({
  isEdicao,
  vendedores,
  setVendedores,
  catalogoVendedores,
  equipas,
}) {
  const obterRefVendedor = (item) => String(item?.refvendedor || item?.ref || "").trim();

  const limparTel = (nome) => {
    const s = String(nome ?? "");

    return s.replace(/\s*(TEL\.?:|TL:).*$/i, "").trim();
  };

  const obterNomeVendedor = (item) => limparTel(item?.vendedor || item?.nome || "");

  const refsEquipa = new Set(
    (Array.isArray(equipas) ? equipas : [])
      .flatMap((equipa) => (Array.isArray(equipa?.vendedores) ? equipa.vendedores : []))
      .map((vendedor) => obterRefVendedor(vendedor))
      .filter(Boolean)
  );

  const catalogoDisponivel = (Array.isArray(catalogoVendedores) ? catalogoVendedores : []).filter(
    (vendedor) => !refsEquipa.has(obterRefVendedor(vendedor))
  );

  const totalObjetivosIndividuais = catalogoDisponivel.reduce((total, vendedorCatalogo) => {
    const refVendedor = obterRefVendedor(vendedorCatalogo);

    const vendedorConfigurado = (Array.isArray(vendedores) ? vendedores : []).find(
      (item) => obterRefVendedor(item) === refVendedor
    );

    const valor = Number(vendedorConfigurado?.valor || 0);

    return total + (Number.isFinite(valor) ? valor : 0);
  }, 0);

  const obterVendedorConfigurado = (refVendedor) =>
    (Array.isArray(vendedores) ? vendedores : []).find(
      (item) => obterRefVendedor(item) === refVendedor
    ) || null;

  const alterarValor = (vendedorCatalogo, valor) => {
    const refVendedor = obterRefVendedor(vendedorCatalogo);
    const nomeVendedor = obterNomeVendedor(vendedorCatalogo);

    if (!refVendedor) {
      return;
    }

    setVendedores((prev) => {
      const lista = Array.isArray(prev) ? prev : [];

      const existe = lista.some((item) => obterRefVendedor(item) === refVendedor);

      if (existe) {
        return lista.map((item) =>
          obterRefVendedor(item) === refVendedor
            ? {
                ...item,
                vendedor: nomeVendedor,
                valor,
              }
            : item
        );
      }

      return [
        ...lista,
        {
          id: null,
          refvendedor: refVendedor,
          vendedor: nomeVendedor,
          valor,
        },
      ];
    });
  };

  return (
    <ObjetivoV2AccordionCard
      titulo="Objetivos individuais"
      subtitulo="Define o objetivo individual de cada vendedor. Vendedores associados à equipa não são apresentados nesta lista."
    >
      <MDBox>
        <MDBox mb={2}>
          <MDBox mt={0.5} display="flex" alignItems="center" gap={1}>
            <MDTypography variant="button" fontWeight="bold">
              Total
            </MDTypography>

            <MDInput
              type="number"
              value={totalObjetivosIndividuais}
              disabled
              sx={{
                width: 140,
              }}
            />
          </MDBox>
        </MDBox>

        {catalogoDisponivel.length === 0 ? (
          <MDBox minHeight={90} display="flex" alignItems="center" justifyContent="center">
            <MDTypography variant="button" color="text" textAlign="center">
              Não existem vendedores disponíveis.
            </MDTypography>
          </MDBox>
        ) : (
          <MDBox display="flex" flexDirection="column" gap={1}>
            {catalogoDisponivel.map((vendedorCatalogo) => {
              const refVendedor = obterRefVendedor(vendedorCatalogo);

              const nomeVendedor = obterNomeVendedor(vendedorCatalogo);

              const vendedorConfigurado = obterVendedorConfigurado(refVendedor);

              const valor = vendedorConfigurado?.valor ?? "";

              return (
                <MDBox
                  key={refVendedor}
                  display="grid"
                  gridTemplateColumns={{
                    xs: "1fr",
                    sm: "minmax(0, 1fr) 180px",
                  }}
                  gap={1.5}
                  alignItems="center"
                  py={0.5}
                >
                  <MDTypography variant="button" fontWeight="regular">
                    {nomeVendedor ? `${refVendedor} - ${nomeVendedor}` : refVendedor}
                  </MDTypography>

                  <MDInput
                    type="number"
                    fullWidth
                    value={valor}
                    disabled={!isEdicao}
                    onChange={(e) => {
                      const texto = e.target.value;

                      alterarValor(
                        vendedorCatalogo,
                        texto === "" ? "" : Math.max(0, parseInt(texto, 10) || 0)
                      );
                    }}
                    inputProps={{
                      min: 0,
                      step: 1,
                    }}
                  />
                </MDBox>
              );
            })}
          </MDBox>
        )}
      </MDBox>
    </ObjetivoV2AccordionCard>
  );
}
